//
//
//
//
//

export default {
  props: {
    imgSrc: { // 正式图片路径
      type: String,
      default: ''
    },
    type: { // 模版类型 0--160*60;1---20*20;2---集市；3----文章
      type: String,
      default: '0'
    },
    height: { // 图片宽度
      type: String,
      default: '100%'
    },
    alt: { // img alt属性的值
      type: String,
      default: ''
    }
  },
  data () {
    return {
      src: this.imgSrc
      // src: ''
    }
  },
  computed: {
    defaultImg () { // 模版选择
      let ss = ''
      if (this.type == '0') {
        ss = 'https://resources.interface003.com/web20/img/default/Avatar.png'
      } else if (this.type == '1') {
        ss = 'https://resources.interface003.com/web20/img/default/20-20.png'
      } else if (this.type == '2') {
        ss = 'https://resources.interface003.com/web20/img/default/dealer-default.png'
      } else if (this.type == '3') {
        ss = 'https://resources.interface003.com/web20/img/default/article.png'
      } else if (this.type == '4') { // 用户头像
        ss = 'https://resources.interface003.com/web20/img/default/avader.png'
      }
      return ss
    }
  },
  created () {
    // this.src = this.defaultImg
  }
}
